type StonlyDebugPayload = Record<string, unknown>;

/** Temporary production diagnostics for Stonly help button issues. Remove after root cause is found. */
export const stonlyDebug = (
  message: string,
  payload?: StonlyDebugPayload,
): void => {
  // eslint-disable-next-line no-console
  console.log("[StonlyDebug]", message, payload ?? "");
};

export const getStonlyRuntimeSnapshot = () => {
  const stonlyWidget = (window as Window & {StonlyWidget?: any}).StonlyWidget;
  const stonlyTrack = (window as Window & {stonlyTrack?: any}).stonlyTrack;

  return {
    hasStonlyWidgetStub: Boolean(stonlyWidget),
    hasStonlyWidgetApi: Boolean(stonlyWidget?._api),
    stonlyWidgetQueueLength: stonlyWidget?.queue?.length ?? null,
    hasStonlyTrackStub: Boolean(stonlyTrack),
    hasStonlyTrackApi: Boolean(stonlyTrack?._api),
    stonlyTrackQueueLength: stonlyTrack?.queue?.length ?? null,
    helpButtonInDom: Boolean(document.getElementById("stonly-help-button")),
  };
};
